<button
  type="button"
  class="switch"
  [matTooltip]="tooltipText()"
  [attr.aria-checked]="checked"
  (click)="toggle()"
  (keydown.space)="toggle(); $event.preventDefault()"
  (keydown.enter)="toggle(); $event.preventDefault()">
  <span class="track" aria-hidden="true"></span>
  <span class="thumb" aria-hidden="true">
    <span class="icon material-symbols-outlined">{{ checked ? onIcon : offIcon }}</span>
  </span>
</button>
